/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from "@material-ui/core/";
import { useContext, useState } from "react";
import { config as url } from "../../../common/config";
import FetchDataContext from "../../../context/fetchData/fetchDataContext";
import FormOnEditListGroup from "./FormOnEditListGroup";
import FormOnListGroup from "./FormOnListGroup";
import OptionHandle from "./OptionHandle";
import TableOnListGroup from "./TableOnListGroup";

const ListGroup = () => {
	const BaseUrl = `${url.group}`;
	const fetchData = useContext(FetchDataContext);
	const {
		getDataTables,
		addData,
		updateData,
		deleteData,
		refreshData,
		tableRef,
		MultipleHandleOptions,
		stateOption,
		setStateOption,
	} = fetchData;
	const [state, setState] = useState({
		openAdd: false,
		pageSize: 5,
	});
	const { openAdd, pageSize } = state;
	const [openEdit, setOpenEdit] = useState(false);
	const [data, setData] = useState();
	const [optionChange, setOptionChange] = useState({
		idlayanan: "0",
		idgroup: "0",
	});

	const handleOpenCloseFormAdd = () => {
		setState({ ...state, openAdd: !openAdd });
		setStateOption({ ...stateOption, optionResult: null });
	};

	const handleOpenCloseFormEdit = (params) => {
		setOpenEdit(!openEdit);
		params &&
			stateOption &&
			stateOption.option1.map((row) => {
				stateOption.option2.map((rows) => {
					if (params.layanan === row.nama && params.n_group === rows.nama)
						setData({ ...params, idlayanan: row.id, idgroup: rows.id });
					return rows;
				});
				return row;
			});
	};

	const fetchAPI = async (action, data) => {
		console.log(data);
		let result;
		if (action === "add")
			result = await addData(
				`${BaseUrl}/user/add_user`,
				data,
				handleOpenCloseFormAdd
			);
		if (action === "edit")
			result = await updateData(
				`${BaseUrl}/user/edit_user?id=${data.id}`,
				data,
				handleOpenCloseFormEdit
			);
		if (action === "delete")
			result = await deleteData(
				`${BaseUrl}/user/delete_user?id=${data.id}`,
				data.nama_user
			);
		return result;
	};

	return (
		<Grid direction="column" alignItems="center">
			<OptionHandle
				stateOption={stateOption}
				data={data}
				state={optionChange}
				setState={setOptionChange}
				handleSearch={refreshData}
			/>
			<TableOnListGroup
				getDataTables={getDataTables}
				fetchAPI={fetchAPI}
				BaseUrl={BaseUrl}
				pageSize={pageSize}
				tableRef={tableRef}
				modalAdd={handleOpenCloseFormAdd}
				modalEdit={handleOpenCloseFormEdit}
				state={optionChange}
			/>
			<FormOnListGroup
				stateOption={stateOption}
				MultipleHandleOptions={MultipleHandleOptions}
				open={openAdd}
				fetchAPI={fetchAPI}
				handleClose={handleOpenCloseFormAdd}
			/>
			<FormOnEditListGroup
				fetchAPI={fetchAPI}
				stateOption={stateOption}
				open={openEdit}
				editData={data}
				handleClose={handleOpenCloseFormEdit}
			/>
		</Grid>
	);
};
export default ListGroup;
